import { LitElement, html, css } from "lit";
import { apiService } from "../util/axiosHelper.js";

class JobList extends LitElement {
  static properties = {
    data: { type: Array },
    page: { type: Number },
    topjobid: { type: Array },
    area: { type: Array },
    fileDomain: { type: String },
  };

  constructor() {
    super();
    this.data = [];
    this.page = 1;
    this.topjobid = [];
    this.area = [];
    this.fileDomain = "";
    this.favorite = [];
    this.loadFavorite();
  }

  static styles = css`
    p {
      margin: 0;
    }
    .job-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .job-item {
      position: relative;
      border: 1px solid #ddd;
      border-radius: 8px;
      background: white;
      box-shadow: 0px 1px 10px #00000021;
      padding: 16px;
    }
    .job-item .recommend {
      position: absolute;
      top: 10px;
      right: 10px;
      text-align: center;
      display: flex;
      width: max-content;
      justify-content: center;
      align-items: center;
    }
    .job-item .recommend img {
      height: 40px;
    }
    .job-item .recommend p {
      position: absolute;
      transform: translate(17%, 13%);
      font-size: 1.25rem;
      color: white;
      text-shadow: 0px 3px 6px #10238782;
    }
    .job-item .content {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    .job-item .content .details {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .job-item .content .actions {
      display: flex;
      flex-direction: column;
      gap: 7px;
      justify-content: flex-end;
      width: max-content;
    }
    .job-item .content .actions .updateTime {
      text-align: right;
      font: normal normal normal 14px/16px Arial;
      letter-spacing: 0px;
      color: #b5b5b5;
    }
    .job-item .content .actions .buttons {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: auto;
    }
    .job-item .content .actions .buttons button {
      border: none;
      font-size: 16px;
      line-height: 18px;
      border-radius: 6px;
      display: flex;
      gap: 0.5rem;
      width: auto;
      align-items: center;
      white-space: nowrap;
      cursor: pointer;
    }
    .job-item .content .actions .buttons .save {
      max-width: 84px;
      padding: 6px 14px;
      background: #e9e9e9 0% 0% no-repeat padding-box;
      color: #000000;
    }
    .job-item .content .actions .buttons .save.active {
      background: #56c7bb;
      color: #ffffff;
    }
    .job-item .content .actions .buttons .apply {
      background: #56c7bb 0% 0% no-repeat padding-box;
      color: #ffffff;
      padding: 6px 26px;
    }
    .job-item .content .actions .buttons .icon {
      width: 16px;
      height: 16px;
    }
    .job-item .group .info .title {
      font: 450 18px / 21px Arial;
      color: #1f2937;
      text-decoration: none;
    }
    .job-item .group .info .title p {
      text-decoration: none;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
    }
    .job-item .group .info .title:hover {
      color: #4b5563;
    }
    .job-item .group .info .companyName {
      font-weight: bold;
      font-size: 14px;
      color: #4ebcb1;
      text-decoration: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: 0px;
      line-height: 16px;
    }
    .job-item .group .info .jobInfo p {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 16px;
    }
    .job-item .group {
      display: flex;
      gap: 20px;
      overflow: hidden;
    }
    .job-item .group .logo img {
      width: 60px;
      height: 60px;
      object-fit: contain;
    }
    @media (max-width: 768px) {
      .job-item .group .logo img {
        width: 44px;
        height: 44px;
      }
    }
    @media (max-width: 500px) {
      .job-item .group .logo {
        display: none;
      }
    }
    .job-item .group .info {
      width: auto;
      display: inline-flex;
      flex-direction: column;
      gap: 7px;
      overflow: hidden;
    }
    @media (max-width: 768px) {
      .job-item .group .info {
        flex: 1;
        width: auto;
      }
    }
    @media (max-width: 768px) {
      .job-item .content {
        flex-direction: column;
        gap: 10px;
      }
      .job-item .content .logo {
        display: flex;
        justify-content: center;
      }
      .job-item .content .logo img {
        width: 44px;
        height: 44px;
      }
      .job-item .content .actions {
        width: 100%;
        justify-content: flex-end;
        align-items: flex-end;
      }

      .job-item .content .actions .buttons {
        margin: 0;
      }
      .job-item .group .info .title {
        font-size: 16px;
        line-height: 18px;
      }
      .job-item .group .info .companyName {
        font-size: 12px;
        line-height: 14px;
      }
      .job-item .group .info .jobInfo {
        font-size: 12px;
        line-height: 14px;
      }
      .job-item .group .info .jobInfo p {
        font-size: 12px;
      }
      .job-item .content .actions .updateTime  {
        font-size: 12px;
        line-height: 14px;
      }
    }
    @media (max-width: 500px) {
      .job-item .content .logo {
        display: none;
      }
    }
  `;

  render() {
    return html`
      <div class="job-list">
        ${this.data?.map((job) => this.renderJobItem(job))}
      </div>
    `;
  }

  renderJobItem(job) {
    const updateDate = new Date(job.updateDateTime);
    const jobDate = updateDate.getDate().toString().padStart(2, "0");
    const jobMonth = (updateDate.getMonth() + 1).toString().padStart(2, "0");
    const jobYear = updateDate.getFullYear();

    const path = `${this.fileDomain}company/logo/${job.logo}`;
    const encSaveId =
      this.favorite.find((fav) => fav.encJobId === job.encJobId)?.encSaveId ||
      null;
    job.encSaveId = encSaveId;
    return html`
      <div class="job-item">
        <div class="recommend">
          ${this.topjobid.includes(job.encJobId)
            ? html`
                <img src="./images/icon/findjob_best.png" alt="recommend-job" />
                <p>推薦</p>
              `
            : ""}
        </div>
        <div class="content">
          <div class="group">
            <div class="logo">
              <img
                loading="lazy"
                src="${path}"
                alt="company-img"
                onerror="this.src='${this
                  .fileDomain}company/default/company.png'"
              />
            </div>
            <div class="info">
              <a class="title" href="/job/${job.encJobId}">
                <p title="${job.title}">${job.title}</p>
              </a>
              <a class="companyName" href="/company/${job.encCompanyId}">
                <p>${job.name}</p>
              </a>
              <div class="jobInfo">
                <p>${this.displayJobInfo(job)}</p>
              </div>
            </div>
          </div>
          <div class="actions">
            <p class="updateTime">${jobYear}/${jobMonth}/${jobDate} 更新</p>
            <div class="buttons">
              <button
                class="save ${job.encSaveId ? "active" : ""}"
                @click="${() => this.favoriteJobAction(job)}"
              >
                <svg
                  id="savejobsvg_${job.encJobId}"
                  class="icon"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                  />
                </svg>
                <p>收藏</p>
              </button>
              <button
                class="apply"
                @click="${() => this.applyJob(job.encJobId)}"
              >
                應徵
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  findObjectsByNo(data, targetNo, foundObjects = []) {
    // 如果 targetNo 是字符串，则转换为数组，方便统一处理
    if (!Array.isArray(targetNo)) {
      targetNo = [targetNo];
    }

    // 如果当前数据是一个对象并且具有 "no" 属性，则检查是否与目标 no 匹配
    if (typeof data === "object" && data !== null && "no" in data) {
      if (targetNo.includes(data.no)) {
        foundObjects.push(data); // 如果找到匹配的对象，则将其添加到结果数组中
      }
    }

    // 如果当前数据是一个对象但不具有 "no" 属性，或者是数组，则遍历其属性或元素
    for (let key in data) {
      if (Array.isArray(data[key])) {
        // 如果当前属性是数组，则递归调用函数查找数组中的元素
        for (let item of data[key]) {
          this.findObjectsByNo(item, targetNo, foundObjects);
        }
      } else if (typeof data[key] === "object") {
        // 如果当前属性是对象，则递归调用函数查找对象中的属性
        this.findObjectsByNo(data[key], targetNo, foundObjects);
      }
    }

    // 返回找到的所有匹配对象
    return foundObjects.length > 0 ? foundObjects : [];
  }

  displayJobInfo(item) {
    const displayRequire = () => {
      const numOfRequire = `${
        item.numOfRequire === "限額"
          ? `${item.requireFrom}${item.requireTo ? ` ~ ${item.requireTo}` : ""}`
          : item.numOfRequire
      } 人`;
      return `需求 ${numOfRequire || "未提供"}`;
    };

    const displayAddress = () => {
      const areaObjects = this.findObjectsByNo(this.area, item.areaCode);
      return areaObjects.map((obj) => obj.des).join("") || "未提供";
    };

    const displaySalary = () => {
      let text = "";
      if (item.salaryType != null) {
        if (item.salaryType == "salaryA") text = "論件計酬";
        else if (item.salaryType == "salaryB") text = "待遇面議";
        else {
          text += `${item.salaryCtype} ${Number.parseInt(item.salaryFrom).toLocaleString()}`;
          if (item.salaryCheck) text += `元以上`;
          if (item.salaryTo)
            text += `~${Number.parseInt(item.salaryTo).toLocaleString()}元`;
          else text += `元`;
        }
      }
      return text || "未提供";
    };

    const jobInfoText = `${displaySalary()}｜${displayAddress()}｜${displayRequire()}`;

    return jobInfoText;
  }

  openPageInBlankOrSelf(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const url = target.getAttribute("href");
    if (event.ctrlKey || event.metaKey) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
  }

  favoriteJobAction(job) {
    const jobId = job.encJobId;
    if (!!job.encSaveId == true) {
      apiService
        .getData(`/api/job/favorite/delete/${job.encSaveId}`)
        .then(() => {
          this.loadFavorite();
        });
    } else {
      if (localStorage.getItem("token") == null) {
        createToast("info", "請先進行登入");
        showLoginModal("user", tabState.user.login);
      } else {
        apiService
          .postData("/api/job/favorite/save", { encJobId: jobId })
          .then((res) => {
            this.loadFavorite();
          });
      }
    }
  }

  loadFavorite() {
    localStorage.getItem("token");
    if (localStorage.getItem("token")) {
      apiService.getData("/api/job/favorite", null).then((res) => {
        this.favorite = res.data;
        this.requestUpdate();
      });
    }
  }

  applyJob(encJobId) {
    window.location.href = `/job?encJobId=${encJobId}&action=apply`;
  }
}

customElements.define("wb-job-list", JobList);
